(() => {
  if (customElements.get('cross-sell-desc')) return;

  class CrossSellDesc extends HTMLElement {
    constructor() {
      super();
      this.onToggle = this.onToggle.bind(this);
      this.expanded = false;
    }

    connectedCallback() {
      this.descEl = this.querySelector('[data-js-desc]');
      this.toggleBtn = this.querySelector('[data-js-toggle]');
      this.labelMore = this.querySelector('[data-js-label-more]');
      this.labelLess = this.querySelector('[data-js-label-less]');

      if (!this.descEl || !this.toggleBtn) return;

      this.toggleBtn.addEventListener('click', this.onToggle);
      this.resizeObserver = new ResizeObserver(() => this.updateOverflow());
      this.resizeObserver.observe(this.descEl);

      requestAnimationFrame(() => this.updateOverflow());
    }

    disconnectedCallback() {
      this.toggleBtn?.removeEventListener('click', this.onToggle);
      this.resizeObserver?.disconnect();
    }

    isOverflowing() {
      return this.descEl.scrollHeight > this.descEl.clientHeight + 1;
    }

    updateOverflow() {
      if (this.expanded) {
        this.toggleBtn.hidden = false;
        return;
      }

      const overflowing = this.isOverflowing();
      this.toggleBtn.hidden = !overflowing;
    }

    onToggle() {
      this.expanded = !this.expanded;
      this.classList.toggle('is-expanded', this.expanded);
      this.labelMore.hidden = this.expanded;
      this.labelLess.hidden = !this.expanded;
      this.toggleBtn.setAttribute('aria-expanded', String(this.expanded));

      if (!this.expanded) {
        requestAnimationFrame(() => this.updateOverflow());
      }
    }
  }

  customElements.define('cross-sell-desc', CrossSellDesc);
})();
